'use client'

import React, { useState, useEffect } from 'react'
import Image from 'next/image'
import AnimatedSection from '@/components/AnimatedSection'
import styles from './styles.module.css'

const Strategy: React.FC = () => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 767)
    }
    
    checkIsMobile()
    window.addEventListener('resize', checkIsMobile)
    
    return () => window.removeEventListener('resize', checkIsMobile)
  }, [])

  return (
    <section className={styles.strategy}>
      <AnimatedSection animation="slideUp">
        <div className={styles.content}>
          <div className={styles.subtitle}>Стратегия  развития</div>
          <h2 
            className={styles.title}
            dangerouslySetInnerHTML={{ __html: '<span>Выстраиваем поэтапную работу в формате mvp</span>' }}
          />
          <p 
            className={styles.description}
            dangerouslySetInnerHTML={{ __html: 'Для каждого продукта мы проектируем персональный путь развития продукта по MVP — гибкий маршрут, который зависит от ваших бизнес-целей, бюджета и технической сложности решения.<br><br>Это позволяет запустить систему в работу в кратчайшие сроки, постепенно дополняя её сложными модулями и адаптируя продукт под реальный опыт пользователей.' }}
          />
        </div>
      </AnimatedSection>
      <AnimatedSection animation="slideUp">
        <div className={styles.visual}>
          {/* Desktop and tablet - show original image */}
          {!isMobile && (
            <Image
              src="/images/complex-solutions/strategy_desktop.svg"
              alt="Стратегия"
              width={1110}
              height={1012}
              className={styles.image}
            />
          )}
          
          {/* Mobile - show mobile image */}
          {isMobile && (
            <Image
              src="/images/complex-solutions/strategy_mobile.svg"
              alt="Стратегия"
              width={242}
              height={547}
              className={styles.mobileImage}
            />
          )}
        </div>
      </AnimatedSection>
    </section>
  )
}

Strategy.displayName = 'Strategy'

export default Strategy